import React, { memo, useCallback, useState } from 'react';
import { EditIcon } from '@ui/components';
import {
  IRegion,
  deleteRegion as deleteRegionApi,
} from '@ui/api/v2/regions.api';
import { Modal, notification } from 'antd';
import { replaceSpaceByDash } from '../../utils/helpers';

interface IProps {
  region: IRegion;
  setEditRegion: (region: IRegion) => void;
  onDelete: (id: number) => void;
}

function RegionCard({ region, setEditRegion, onDelete }: IProps) {
  const [showModal, setShowModal] = useState(false);

  const onEditClick = useCallback(() => {
    setEditRegion(region);
  }, [region, setEditRegion]);

  const deleteRegion = useCallback(async () => {
    setShowModal(false);
    const { error } = await deleteRegionApi(region.id);
    if (error) {
      notification.error({
        message: error.response.data.message,
      });
    } else {
      onDelete(region.id);
    }
  }, [region.id, onDelete, setShowModal]);

  return (
    <div className="regions__item">
      <span>{replaceSpaceByDash(region.name)}</span>
      <span>{region.country.name}</span>
      <span />
      <div className="regions__controls">
        <EditIcon onClick={onEditClick} type="edit" />
        <EditIcon onClick={() => setShowModal(true)} type="remove" />
      </div>
      <Modal
        okButtonProps={{
          style: {
            width: '120px',
          },
          size: 'large',
          type: 'danger',
        }}
        cancelButtonProps={{
          style: {
            width: '120px',
          },
          size: 'large',
          type: 'primary',
        }}
        okText="Да"
        cancelText="Нет"
        title="Удаление области"
        visible={showModal}
        onOk={deleteRegion}
        onCancel={() => setShowModal(false)}
      >
        <p>Вы уверены, что ходите удалить область {region.name}</p>
      </Modal>
    </div>
  );
}

export default memo(RegionCard);



// WEBPACK FOOTER //
// ./src/components/Regions/RegionCard.tsx